module.exports = __webpack_public_path__ + "img/horizontal_7_2_6005.d33c7f80.png";